import { createFileRoute, redirect } from '@tanstack/react-router';
import { ModifyTagsPage } from '../components/profile/settings/ModifyTagsPage';

export const Route = createFileRoute('/profile/settings/tags')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: ModifyTagsPage,
});
